import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: idevo89
 * id CFE12054-7E04-4144-B0CA-0DA9FE494E82
 * name delete-alert-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const DeleteAlertOutlineIcon = createSvgIcon(<><path d="M4 19V7H16V19C16 20.1 15.1 21 14 21H6C4.9 21 4 20.1 4 19M6 9V19H14V9H6M13.5 4H17V6H3V4H6.5L7.5 3H12.5L13.5 4M19 17V15H21V17H19M19 13V7H21V13H19Z" /></>, 'DeleteAlertOutlineIcon');
export default DeleteAlertOutlineIcon